module.exports = __webpack_public_path__ + "static/media/ic-mob-filter.ae88d9a2.svg";